// src/services/security-roles.ts
import api from "./api";
import {
  SecurityRolesResponse,
  CreateRoleRequest,
  UpdateRoleRequest,
  AssignRoleRequest,
  Role,
  SecurityPolicy,
  SecurityPolicyForm,
} from "../types/security-roles";

export const securityRolesService = {
  // Get all security and roles data
  getSecurityRoles: async (): Promise<SecurityRolesResponse> => {
    const response = await api.get("/security");
    return response.data; // This should be { success: true, data: {...} }
  },

  // Role management
  createRole: async (data: CreateRoleRequest): Promise<{ data: Role }> => {
    const response = await api.post("/security/roles", data);
    return response.data;
  },

  updateRole: async (
    id: string,
    data: UpdateRoleRequest
  ): Promise<{ data: Role }> => {
    const response = await api.put(`/security/roles/${id}`, data);
    return response.data;
  },

  deleteRole: async (
    id: string
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/security/roles/${id}`);
    return response.data;
  },

  // User role assignment
  assignRole: async (data: AssignRoleRequest): Promise<{ data: any }> => {
    const response = await api.post("/security/assign-roles", data);
    return response.data;
  },

  revokeUserRole: async (
    assignmentId: string,
    reason?: string
  ): Promise<{ success: boolean; message: string }> => {
    const response = await api.patch(`/security/revoke-role/${assignmentId}`, {
      reason,
    });
    return response.data;
  },

  // Security policy
  updateSecurityPolicy: async (
    policy: any
  ): Promise<{ data: SecurityPolicy }> => {
    const response = await api.put("/security/policy", policy);
    return response.data;
  },

  // User permissions
  getUserPermissions: async (
    userId: string
  ): Promise<{
    data: {
      userId: string;
      permissions: string[];
      roles: Array<{
        roleId: string;
        roleName: string;
        displayName: string;
        branchId?: string;
        validFrom: string;
        validUntil?: string;
      }>;
    };
  }> => {
    const response = await api.get(`/security/user-permissions/${userId}`);
    return response.data;
  },
};
